let config = {
  sdk: 'NIM_Web_SDK_v4.7.0.js',
  // 用户自定义的登录注册地址
  loginUrl: '/webdemo/h5/login.html',
  registUrl: '/webdemo/h5/regist.html',
  homeUrl: '/webdemo/h5/index.html#/session',

  // 资源路径根目录，为了方便用户部署在二级以上URL路径上
  resourceUrl: '/webdemo/h5/res',
  // 用户logo地址
  logo: '/webdemo/h5/res/im/logo.png',
  // 默认用户头像
  defaultUserIcon: '/webdemo/h5/res/im/default-icon.png',
  // 默认普通群头像
  defaultGroupIcon: '/webdemo/h5/res/im/default-group.png',
  // 默认高级群头像
  defaultAdvancedIcon: '/webdemo/h5/res/im/default-advanced.png',
  // 系统通知图标
  noticeIcon: '/webdemo/h5/res/im/notice-icon.png',
  // 我的手机图标
  myPhoneIcon: '/webdemo/h5/res/im/my-phone.png',
  // 本地消息显示数量，会影响性能
  localMsglimit: 36
}

const env = 'online'

let appConfig = {
  // 用户的appkey
  // 用于在web demo中注册账号异步请求demo 服务器中使用
  test: {
    appkey: '841253055b0f7644802da19933e2917a',
    postUrl: 'http://optimize.newdhb.com/api.php'
  },
  online: {
    appkey: '841253055b0f7644802da19933e2917a',
    postUrl: 'http://optimize.newdhb.com/api.php'
  }
}

config = Object.assign(config, appConfig[env])

export default config





// WEBPACK FOOTER //
// ./src/configs/index.js